import { Link } from '@packages/modules/src/Link/Link';
import { Image } from '@packages/shared/src/ui/Image/Image';
import { Card, CardContent, CardHeader } from '@packages/shared/src/ui/Card/Card';
import { abbreviateString } from '../../utils/abbreviateString';
import type { RelatedContentItemType } from './types';

export const RelatedContentItem = ({
  headline,
  description,
  path,
  teaser_image,
}: RelatedContentItemType) => (
  <Card className="relative min-h-[23rem]">
    <CardHeader className="p-0">
      {teaser_image?.url && (
        <Image
          src={teaser_image.url}
          alt={teaser_image.alt || teaser_image.title || 'Teaser Image'}
          width={teaser_image.width || 100}
          height={teaser_image.height || 100}
          className="rounded-t"
        />
      )}
    </CardHeader>
    <CardContent className="flex flex-col gap-1.5">
      <Link
        href={path}
        passHref
        className="text-size-headline-xl block after:absolute after:top-0 after:left-0 after:size-full"
      >
        {abbreviateString(headline, 40)}
      </Link>
      <div className="text-size-body-sm">{abbreviateString(description, 109)}</div>
    </CardContent>
  </Card>
);
